import { useTranslation } from 'react-i18next';
import { Typography } from '@kizen/kds/Typography';

import Modal from 'components/Modals/presets/BasicModal';

export const UnsavedChangesDialog = (props: any) => {
  const { t } = useTranslation();

  return (
    <Modal {...props} heading={t('Cancel Changes')} buttonText={t('Continue')}>
      <div className="pb-2">
        <Typography>
          {t('Unsaved changes will be lost, would you like to continue?')}
        </Typography>
      </div>
    </Modal>
  );
};
